import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    ${props => props.theme.breakpoints.down('xs')} {
        padding: 16px 40px;
    }
    ${props => props.theme.breakpoints.up('sm')} {
        padding: 16px 128px;
    }
`;

const Container = ({ children }) => {
    return (
        <Wrapper>
            {children}
        </Wrapper>
    )
}

export default Container;